import { useParams,useLocation } from "react-router-dom";

export type HomeRouteMode =
  | "home"
  | "city"
  | "filter"
  | "city_filter"
  | "home_filter"
  | "all_restaurants";

export function useHomeRouteMode(activeSearch: boolean): {mode: HomeRouteMode;city?: string;filter?: string;} {
  const { city, filter } = useParams<{city?: string;filter?: string }>();
  const location = useLocation();
  const isAllRestaurantsPage = location.pathname === "/restaurants";
  if (isAllRestaurantsPage) return { mode: "all_restaurants"};

  const isCategoryRoute = location.pathname.startsWith("/category/");

  if (isCategoryRoute && filter) return { mode: "filter", filter };

  if (city && filter) return { mode: "city_filter", city, filter };

  if (city) return { mode: "city", city };

  if (activeSearch) return { mode: "home_filter", city, filter };

  return { mode: "home" };
}